export default class FormError {
  requiredError() {
    return 'Campo obrigatório';
  }

  cpfError() {
    return 'CPF inválido';
  }

  maxLengthError(maxLength) {
    return `Tamanho máximo de ${maxLength} caracteres`;
  }

  minLengthError(minLength) {
    return `Tamanho mínimo de ${minLength} caracteres`;
  }

  greaterThanError(greaterThan) {
    return `Valor acima de ${greaterThan} obrigatório`;
  }

  lowerThanError(lowerThan) {
    return `Valor abaixo de ${lowerThan} obrigatório`;
  }

  emailError() {
    return 'E-mail inválido';
  }

  dateError() {
    return 'Data inválida';
  }

  maxAgeError(age) {
    return `Idade máxima é de ${age} anos`;
  }

  minAgeError(age) {
    return `Idade mínima é de ${age} anos`;
  }

  zipCodeError() {
    return 'CEP inválido';
  }

  fullNameError() {
    return 'Nome completo obrigatório';
  }

  invalidValueError() {
    return 'Valor inválido';
  }

  matchPasswordError() {
    return 'As senhas não coincidem';
  }

  onlyLettersAndSpacesError() {
    return 'Apenas letras e espaços são permitidos';
  }

  differentFromError(alias) {
    return `Não pode ser igual ao ${alias}`;
  }
}
